import { render, staticRenderFns } from "./NoPlanetB.vue?vue&type=template&id=d5e741ba&"
import script from "./NoPlanetB.vue?vue&type=script&lang=ts&"
export * from "./NoPlanetB.vue?vue&type=script&lang=ts&"
import style0 from "./NoPlanetB.vue?vue&type=style&index=0&id=d5e741ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports